// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__qEQ1Q","title":"AfterFrontImage_title__1YS5i"};